// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-jsx": function componentSrcPages404Jsx() {
    return import("./../../src/pages/404.jsx"
    /* webpackChunkName: "component---src-pages-404-jsx" */
    );
  },
  "component---src-pages-auth-jsx": function componentSrcPagesAuthJsx() {
    return import("./../../src/pages/auth.jsx"
    /* webpackChunkName: "component---src-pages-auth-jsx" */
    );
  },
  "component---src-pages-dev-404-page-jsx": function componentSrcPagesDev404PageJsx() {
    return import("./../../src/pages/dev-404-page.jsx"
    /* webpackChunkName: "component---src-pages-dev-404-page-jsx" */
    );
  },
  "component---src-pages-en-index-jsx": function componentSrcPagesEnIndexJsx() {
    return import("./../../src/pages/en/index.jsx"
    /* webpackChunkName: "component---src-pages-en-index-jsx" */
    );
  },
  "component---src-pages-en-profile-jsx": function componentSrcPagesEnProfileJsx() {
    return import("./../../src/pages/en/profile.jsx"
    /* webpackChunkName: "component---src-pages-en-profile-jsx" */
    );
  },
  "component---src-pages-en-statistics-jsx": function componentSrcPagesEnStatisticsJsx() {
    return import("./../../src/pages/en/statistics.jsx"
    /* webpackChunkName: "component---src-pages-en-statistics-jsx" */
    );
  },
  "component---src-pages-index-jsx": function componentSrcPagesIndexJsx() {
    return import("./../../src/pages/index.jsx"
    /* webpackChunkName: "component---src-pages-index-jsx" */
    );
  },
  "component---src-pages-profile-jsx": function componentSrcPagesProfileJsx() {
    return import("./../../src/pages/profile.jsx"
    /* webpackChunkName: "component---src-pages-profile-jsx" */
    );
  },
  "component---src-pages-statistics-jsx": function componentSrcPagesStatisticsJsx() {
    return import("./../../src/pages/statistics.jsx"
    /* webpackChunkName: "component---src-pages-statistics-jsx" */
    );
  },
  "component---src-pages-techwork-tsx": function componentSrcPagesTechworkTsx() {
    return import("./../../src/pages/techwork.tsx"
    /* webpackChunkName: "component---src-pages-techwork-tsx" */
    );
  }
};